import { Component, ElementRef, Inject} from "@angular/core";
import { NgbActiveModal, NgbModalRef, NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { FormGroup, FormControl, FormBuilder, Validators } from '@angular/forms';
import { Router } from "@angular/router";
import * as jQuery from "jquery";
import { DataService } from "../../../services/data/data.service";
import { TradeRequestModel } from '../../../model/trade.request.data';


@Component({
    selector: "modal-orderchange",
    template: require('./orderchange.component.html'),
    styles: [require('./orderchange.component.css')]
})

export class OrderChangeModal {

    
   private _orderRowData:any;

  public set orderRowData(v:any)
  {
      this._orderRowData=v;
      this.orderQty=this.orderRowData.quantity;
      this.orderPrice= this.orderRowData.submittedprice;
  }

  public get orderId()
  {
      return this.orderRowData.id;
  }

  public get orderSymbol()
  {
      return this.orderRowData.symbol;
  }

  public get orderSide()
  {
      return this.orderRowData.direction;
  }


  private _orderPrice:number=0;


  public set orderPrice(v:number)
  {
      this._orderPrice = v;
  }

  public get orderPrice()
  {
      return this._orderPrice
  }

  private _orderQty:number=0;

  public get orderQty()
  {
      return this._orderQty;
  }

  public set orderQty(v:number)
  {
      this._orderQty = v;;
  }

  public get orderRowData():any{
      return this._orderRowData;
  }
    constructor(
        private router: Router,
        private fb: FormBuilder,
        public activeModal: NgbActiveModal,
        private dataService: DataService,
      //  public orderDeleteData:deleteOrderRequest
    ) {

    }

    changeOrder()
    { 
        this.sendChangeRequest();
        this.activeModal.close();
       
    }

    
    private _currentRequestId:string="";
    
    sendChangeRequest():void
    {
       
            let orderChangeData:changeOrderRequest={
                Cmd:DataService.TYPE_REPLACETRADE,
                Symbols:[],
                CXR:{
                    ClOrdId:this.orderRowData.id,
                    NewQty:this.orderQty,
                    NewPrice:this.orderPrice
                }
            };

      //  this._currentRequestId =  "_TRADE_" + this.tradeData.Type + this.tradeData.Side + this.tradeData.Symbol + Date.now().toString();;

      //  console.log( this._currentRequestId);  
      //  console.log(this.tradeData);
      //  orderDeleteData.Cmd=DataService.TYPE_CANCELTRADE;
     //   this.orderDeleteData.CXL.ClOrdId=this.orderRowData.id;
       this.dataService.sendRequest(orderChangeData);

    }

}

export function ShowOrderChangeModal(modalService: NgbModal, orderData:any){
    let m:NgbModalRef= modalService.open(OrderChangeModal,{
        backdrop: "static",
        size: "sm",
        centered: true, 
        windowClass: "dark-modal"
    });
    let modal = (<OrderChangeModal>m.componentInstance);
    modal.orderRowData = orderData;

}
//{"Cmd":"cxl","Symbols":[],"CXL":{"ClOrdId":"201808051000085"}}
export interface changeOrderRequest
{
    Cmd:string,
    Symbols:string[],
    CXR:{
        ClOrdId:string,
        NewQty:number,
        NewPrice:number
    }
}

